var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon icon__chevron--system icon--style--outline icon--size--large",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M12 17a1 1 0 01-.625-.219l-10-8a1 1 0 111.25-1.562l9.375 7.5 9.375-7.5a1 1 0 111.25 1.562l-10 8A1 1 0 0112 17z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }